export type EventTag = 'careers' | 'founders' | 'ai' | 'community' | 'bhm' | 'cyber' | 'data' | 'healthtech';

export interface Event {
  start: string;
  end?: string;
  time?: string;
  title: string;
  where: string;
  desc: string;
  tags: EventTag[];
  url: string;
  free?: boolean;
  pick?: boolean;
}

export const MANCHESTER_EVENTS: Event[] = [
  // October 2026
  {
    start: '2026-10-01',
    title: 'MD Tech Leader Talks 26: From AI ambition to action',
    where: 'Manchester',
    desc: 'Manchester Digital event on practical AI adoption and measurable ROI for tech leaders.',
    tags: ['ai', 'careers'],
    url: 'https://www.manchesterdigital.com/event/manchester-digital/md-tech-leader-talks-26-from-ai-ambition-to-action-delivering-measurable-roi'
  },
  {
    start: '2026-10-01',
    title: 'Women\'s Health Technology Summit 2026',
    where: 'University of Manchester',
    desc: 'Digital Futures event at the intersection of tech, innovation and health.',
    tags: ['healthtech', 'community'],
    url: 'https://www.investmanchester.co.uk/event/womens-health-technology-summit-2026/'
  },
  {
    start: '2026-10-01',
    title: 'Shaping the Future of Women\'s Health: Tech, Equity & Innovation',
    where: 'Manchester',
    desc: 'Founders, healthcare leaders and innovators exploring tech, equity and innovation in women\'s health.',
    tags: ['healthtech', 'founders', 'community'],
    url: 'https://community.venturecafemanchester.org/events/45'
  },
  {
    start: '2026-10-07',
    title: 'Manchester Black Business Conference 2026',
    where: 'Manchester',
    desc: 'Major BHM event focused on Black entrepreneurs, professionals, business leaders, networking and growth.',
    tags: ['bhm', 'founders', 'community'],
    pick: true,
    url: 'https://www.eventbrite.co.uk/e/manchester-black-business-conference-tickets-1988743246586'
  },
  {
    start: '2026-10-07',
    title: 'The Roads We Walked: The Fifth Pan-African Congress',
    where: 'Manchester',
    desc: 'Event exploring Manchester\'s Black history and intellectual/cultural ecosystem.',
    tags: ['bhm', 'community'],
    url: 'https://www.iwm.org.uk/events/the-roads-we-walked-the-fifth-pan-african-congress'
  },
  {
    start: '2026-10-09',
    title: 'Innovation Nation / Growth & Reform Network conference',
    where: 'Manchester',
    desc: 'Government-backed innovation-focused conference involving business, science and regional growth figures.',
    tags: ['founders', 'ai'],
    url: 'https://www.manchesterdigital.com/events'
  },
  {
    start: '2026-10-12',
    title: 'Future-proofing your career in the age of AI & Data',
    where: 'Manchester',
    desc: 'Tech careers, AI and data event during Women in Tech Week.',
    tags: ['ai', 'careers', 'data', 'community'],
    url: 'https://www.manchesterdigital.com/event/nimble-approach/future-proofing-your-career-in-the-age-of-ai-and-data'
  },
  {
    start: '2026-10-13',
    end: '2026-10-14',
    title: 'Data Decoded MCR 2026',
    where: 'Manchester',
    desc: 'One of the bigger specialist events covering AI, GenAI/LLMs, data engineering, governance, DataOps and ML.',
    tags: ['data', 'ai'],
    url: 'https://datadecoded.com/mcr/'
  },
  {
    start: '2026-10-13',
    title: 'PyDataMCR @ Data Decoded',
    where: 'Manchester',
    desc: 'Manchester Python/data community event within Data Decoded.',
    tags: ['data', 'ai'],
    url: 'https://datadecoded.com/mcr/'
  },
  {
    start: '2026-10-13',
    title: 'Northern Azure User Group October Meetup',
    where: 'Manchester',
    desc: 'Enterprise AI tooling and data/AI infrastructure on Azure.',
    tags: ['ai', 'data'],
    url: 'https://www.meetup.com/northern-azure-user-group/'
  },
  {
    start: '2026-10-14',
    title: 'Mage Camp',
    where: 'Manchester',
    desc: 'Full-day event for Magento/Adobe Commerce merchants and the wider ecosystem.',
    tags: ['founders'],
    url: 'https://mage.camp/tickets'
  },
  {
    start: '2026-10-14',
    title: 'UK CyberSpine Demo Day',
    where: 'DiSH, Manchester',
    desc: 'Cybersecurity startups presenting to investors and corporate security buyers.',
    tags: ['cyber', 'founders'],
    url: 'https://www.manchesterdigital.com/events'
  },
  {
    start: '2026-10-14',
    title: 'UK Cyber investment landscape discussion & networking',
    where: 'Manchester',
    desc: 'Cyber founders and investors networking event.',
    tags: ['cyber', 'founders'],
    url: 'https://www.manchesterdigital.com/events'
  },
  {
    start: '2026-10-16',
    title: 'AmafestUK \u2013 Amazon Sellers Conference',
    where: 'Manchester',
    desc: 'Large e-commerce-focused event for Amazon sellers and digital entrepreneurs.',
    tags: ['founders'],
    url: 'https://amafestuk.com/'
  },
  {
    start: '2026-10-19',
    title: 'Inaugural Manchester Turing Lecture \u2013 Prof Sir Bashir M. Al-Hashimi',
    where: 'University of Manchester',
    desc: 'Strong academic/computing event at the University of Manchester.',
    tags: ['ai'],
    url: 'https://www.anopenroom.com/manchester/events/the-inaugural-manchester-turing-lecture-prof-sir-bashir-m-al-hashimi-1019'
  },
  {
    start: '2026-10-21',
    title: 'Infosec Manchester & SentinelOne Techie Brekkie',
    where: 'Manchester',
    desc: 'Security-focused community event.',
    tags: ['cyber', 'community'],
    url: 'https://infosecmanchester.com/'
  },
  {
    start: '2026-10-22',
    title: 'Venture Caf\u00e9 Manchester: One Year On',
    where: 'Manchester',
    desc: 'Founder/startup ecosystem and networking.',
    tags: ['founders', 'community'],
    url: 'https://community.venturecafemanchester.org/events/34'
  },
  {
    start: '2026-10-22',
    title: 'Graph Engineering + Inclusion Debt',
    where: 'Manchester',
    desc: 'Applied AI/software engineering meetup with an inclusion angle.',
    tags: ['ai', 'community'],
    url: 'https://www.meetup.com/find/gb--18--manchester/'
  },
  {
    start: '2026-10-28',
    title: 'Black History Month 2026 Celebration \u2013 Sister / Renold Building',
    where: 'University of Manchester',
    desc: 'BHM celebration at Manchester\'s tech/university ecosystem.',
    tags: ['bhm', 'community'],
    url: 'https://events.manchester.ac.uk/'
  },
  {
    start: '2026-10-29',
    title: 'Those Serendipitous Mavericks: The Ratio Club & early British Cybernetics',
    where: 'Manchester',
    desc: 'Interesting historical/academic technology event from Digital Futures.',
    tags: ['ai'],
    url: 'https://events.manchester.ac.uk/event/event:i2z-ms8r22tf-dedrmp/those-serendipitous-mavericks-the-ratio-club-and-early-british-cybernetics'
  },
  {
    start: '2026-10-30',
    time: '9:30 AM - 12:30 PM',
    title: 'Funding Readiness Co-working Club',
    where: 'DiSH, Manchester',
    desc: 'Hands-on co-working session for founders preparing for investment, hosted by Barclays Eagle Labs.',
    tags: ['founders'],
    free: true,
    url: 'https://www.eventbrite.co.uk/e/funding-readiness-co-working-club-tickets-1993817510847'
  },
  {
    start: '2026-10-31',
    title: 'Black History Month Storytelling with CALFE \u2013 Manchester Museum',
    where: 'Manchester Museum',
    desc: 'Cultural BHM event with storytelling at Manchester Museum.',
    tags: ['bhm', 'community'],
    url: 'https://www.museum.manchester.ac.uk/event'
  },
  // November 2026
  {
    start: '2026-11-03',
    title: 'Manchester Tech Network \u2013 Evening Drinks',
    where: 'Manchester',
    desc: 'Informal tech networking for developers, PMs, designers, UX, data/AI and founders.',
    tags: ['community', 'careers'],
    url: 'https://www.meetup.com/manchester-tech-network/'
  },
  {
    start: '2026-11-07',
    end: '2026-11-08',
    title: 'GreatUniHack 2026',
    where: 'University of Manchester',
    desc: '30+ hour student hackathon with hundreds of student builders, mentors and engineers.',
    tags: ['community', 'careers'],
    url: 'https://greatunihack.com/'
  },
  {
    start: '2026-11-10',
    title: 'GROWTH:SUMMIT:26',
    where: 'Manchester',
    desc: '300-person summit for technology/GTM leaders, focused on getting AI implementations from pilots into measurable business value.',
    tags: ['ai', 'founders'],
    url: 'https://summit.sixandflow.com/'
  },
  {
    start: '2026-11-12',
    title: 'AI Governance Reality Check',
    where: 'Manchester',
    desc: 'Practical discussion on AI governance for business leaders.',
    tags: ['ai'],
    url: 'https://www.manchesterdigital.com/events'
  },
  {
    start: '2026-11-12',
    title: 'Manchester Technology Leaders Conference',
    where: 'The Lowry, Manchester',
    desc: 'Major event covering AI, data, transformation and accountability for CIO/CTO/technology leadership.',
    tags: ['ai', 'careers'],
    url: 'https://www.xpertise-recruitment.com/'
  },
  {
    start: '2026-11-12',
    title: 'From AI Technology to Business Innovation \u2013 GFT + Google',
    where: 'Manchester',
    desc: 'AI and business innovation event by GFT and Google.',
    tags: ['ai', 'founders'],
    url: 'https://www.manchesterdigital.com/events'
  },
  {
    start: '2026-11-12',
    title: 'Manchester Data Intelligence Network',
    where: 'Manchester',
    desc: 'Data, analytics and networking event.',
    tags: ['data', 'community'],
    url: 'https://www.meetup.com/'
  },
  {
    start: '2026-11-18',
    title: 'Digital Trust & Security Seminar \u2013 University of Manchester',
    where: 'University of Manchester',
    desc: 'Academic seminar on cyber and digital trust.',
    tags: ['cyber'],
    url: 'https://events.manchester.ac.uk/'
  },
  {
    start: '2026-11-18',
    title: 'Data & Machine Learning in the Cyber Domain',
    where: 'Manchester',
    desc: 'AI/ML and cybersecurity intersection event.',
    tags: ['ai', 'cyber', 'data'],
    url: 'https://www.anopenroom.com/manchester/events'
  },
  {
    start: '2026-11-19',
    title: 'Human vs AI Intelligence & Cyber Risk',
    where: 'Manchester',
    desc: 'Discussion on AI and cyber risk.',
    tags: ['ai', 'cyber'],
    url: 'https://www.manchesterdigital.com/events'
  },
  {
    start: '2026-11-19',
    title: 'Tech Without Boundaries: Tackling the Social Class Gap',
    where: 'Manchester',
    desc: 'Tech and inclusion event addressing social class barriers.',
    tags: ['community', 'careers'],
    url: 'https://www.manchesterdigital.com/events'
  },
  {
    start: '2026-11-20',
    title: 'Tech Talks with Manchester Met',
    where: 'Manchester Met',
    desc: 'Technology and higher education event.',
    tags: ['careers', 'ai'],
    url: 'https://www.mmu.ac.uk/'
  },
  {
    start: '2026-11-26',
    title: 'UK Digital Economy Conference 2026',
    where: 'Manchester',
    desc: 'techUK\'s conference focused on technology, digital infrastructure, innovation, devolution and regional economic growth.',
    tags: ['founders', 'ai'],
    url: 'https://www.techuk.org/what-we-deliver/events.html'
  },
  {
    start: '2026-11-26',
    title: 'Ghost in the Machine: The Battle for the Human Mind',
    where: 'Manchester',
    desc: 'AI, cybernetics and technology event exploring the future of human-machine interaction.',
    tags: ['ai'],
    url: 'https://events.manchester.ac.uk/'
  },
  {
    start: '2026-11-28',
    title: 'Healthcare Under Siege: Cyber Security for Healthcare Professionals',
    where: 'Manchester',
    desc: 'Cybersecurity and healthtech event for healthcare professionals.',
    tags: ['cyber', 'healthtech'],
    url: 'https://www.anopenroom.com/manchester/events'
  },
  // December 2026
  {
    start: '2026-12-01',
    title: 'Code Anxiety Club',
    where: 'Manchester',
    desc: 'Data and coding community event.',
    tags: ['data', 'community'],
    url: 'https://www.meetup.com/'
  },
  {
    start: '2026-12-02',
    end: '2026-12-04',
    title: 'Computing Insight UK (CIUK) 2026',
    where: 'Manchester Central',
    desc: 'Major conference on HPC, scientific computing, software, research with around 50 exhibitors.',
    tags: ['ai', 'data'],
    url: 'https://www.sc.stfc.ac.uk/ciuk-2026/'
  },
  {
    start: '2026-12-04',
    title: 'Women in HPC Breakfast @ CIUK',
    where: 'Manchester Central',
    desc: 'Women in tech and HPC networking breakfast at CIUK.',
    tags: ['community', 'data'],
    url: 'https://www.sc.stfc.ac.uk/ciuk-2026/'
  },
  {
    start: '2026-12-09',
    title: 'Manchester D365PPUG',
    where: 'Manchester',
    desc: 'Dynamics 365, Power Platform, AI and the changing role of human consultancy skills.',
    tags: ['ai', 'community'],
    url: 'https://www.d365ppug.com/'
  },
];

export const TAG_LABELS: Record<EventTag, string> = {
  careers: 'Careers',
  founders: 'Founders',
  ai: 'AI',
  community: 'Community',
  bhm: 'BHM',
  cyber: 'Cyber',
  data: 'Data',
  healthtech: 'Healthtech'
};

export const FILTER_LABELS: Record<EventTag | 'all', string> = {
  all: 'All',
  careers: 'Careers',
  founders: 'Founders & investors',
  ai: 'AI',
  community: 'Community',
  bhm: 'Black History Month',
  cyber: 'Cybersecurity',
  data: 'Data & ML',
  healthtech: 'Healthtech'
};

export const BRAGBOOQ_URL = 'https://bragbooq.com';

// Helper functions
export const parseDate = (dateStr: string): Date => {
  return new Date(dateStr + 'T00:00:00');
};

export const getUpcomingEvents = (events: Event[]): Event[] => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return events
    .filter(e => parseDate(e.end || e.start) >= today)
    .sort((a, b) => parseDate(a.start).getTime() - parseDate(b.start).getTime());
};

export const getPastEvents = (events: Event[]): Event[] => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return events
    .filter(e => parseDate(e.end || e.start) < today)
    .sort((a, b) => parseDate(b.start).getTime() - parseDate(a.start).getTime()); // Most recent first
};

export const getPickEvent = (events: Event[]): Event | undefined => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return events.find(e => e.pick && parseDate(e.end || e.start) >= today);
};

export const groupEventsByMonth = (events: Event[]): Map<number, Event[]> => {
  const groups = new Map<number, Event[]>();

  events.forEach(e => {
    const date = parseDate(e.start);
    const key = date.getFullYear() * 100 + date.getMonth();
    const existing = groups.get(key) || [];
    groups.set(key, [...existing, e]);
  });

  return groups;
};

export const getMonthName = (key: number): string => {
  const months = ['January', 'February', 'March', 'April', 'May', 'June',
                  'July', 'August', 'September', 'October', 'November', 'December'];
  return months[key % 100];
};

export const getShortMonthName = (date: Date): string => {
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return months[date.getMonth()];
};

export const getWeekdayShort = (date: Date): string => {
  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  return days[date.getDay()];
};
